module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"fail_fetch_backlinks":"Backlinks : Error encountered","load_data":"Load data"},"fr":{"fail_fetch_backlinks":"Backlinks : Nous avons rencontré une erreur","load_data":"Charger les données"},"de":{"fail_fetch_backlinks":"Backlinks: Es ist ein Fehler aufgetreten","load_data":"Daten laden"}}')
  delete Component.options._Ctor
}
